var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEiffelTower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V4H11.1451C10.7832 4 10.4843 4.28273 10.4642 4.64408C10.32 7.23973 9.84731 9.7946 9.06567 12.25H14.9343C14.1527 9.7946 13.68 7.23973 13.5358 4.64408C13.5157 4.28273 13.2168 4 12.8549 4H12.75V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6422 19.9633C17.3411 18.0117 16.2739 15.9262 15.4549 13.75H8.54506C7.72607 15.9262 6.65886 18.0117 5.35782 19.9633L4 22H9V21C9 19.3431 10.3431 18 12 18C13.6569 18 15 19.3431 15 21V22H20L18.6422 19.9633Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEiffelTower);
export default __webpack_public_path__ + "static/media/eiffel-tower.9281b2d23cd0c0f38c3c41664fe97082.svg";
export { ForwardRef as ReactComponent };